/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import { useDisclose } from "@/hooks/utilHooks";
import theme from "@/styles/themes/theme";
import { Breadcrumbs as MuiBreadcrumbs, Button, Stack, Typography, Divider } from "@mui/material";
import { FileText } from "@phosphor-icons/react";

import { NextMuiLink } from "../Link/NextMuiLink";
import { Regulation } from "../Regulation";
import { styles } from "./styles";
import { BreadcrumbsProps } from "./types";
import { sanitizeText } from "@/utils/string";

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.preventDefault();
}

export const BreadcrumbsHeader: React.FC<BreadcrumbsProps> = ({
  items,
  titleHeader,
  regulationPdf,
  regulationHtml,
  allowDownload,
  partnerName
}: BreadcrumbsProps) => {
  const { onOpen, onClose, isOpen } = useDisclose();

  const handleOnOpen = () => {
    try {
      const sanitizedPartnerName = typeof partnerName === "string" ? sanitizeText(partnerName) : "";
      if ((window as any).dataLayer) {
        (window as any).dataLayer.push({
          event: "user_interaction",
          detail: "regulamento_da_parceria",
          description: `parceiro:${sanitizedPartnerName}`
        });
        console.log(`Evento disparado: parceiro:${sanitizedPartnerName}`);
      }
    } catch (error) {
      console.error("Erro ao enviar o evento para o Google Tag Manager", error);
    }

    onOpen();
  };
  return (
    <Stack
      sx={{
        height: "auto",
        bgcolor: theme.palette.grey[200],
        display: "flex",
        flexDirection: { sm: "row", xs: "column" },
        alignItems: { sm: "center", xs: "start" },
        justifyContent: "space-between",
        mt: 1,
        py: 4,
        px: { lg: 10, md: 4, sm: 3, xs: 3 }
      }}
    >
      <Stack role="presentation" onClick={handleClick} sx={{ display: "flex", gap: 2 }}>
        <MuiBreadcrumbs aria-label="breadcrumb">
          {items?.map((item, index) => {
            if (item.title === null || item.title === undefined) {
              return null;
            }

            return (
              <NextMuiLink
                key={index}
                underline="hover"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                color="inherit"
                href={item.link ?? ""}
              >
                {item.icon}

                <Typography color={theme.palette.grey[700]}>{item.title}</Typography>
              </NextMuiLink>
            );
          })}
        </MuiBreadcrumbs>

        {typeof titleHeader === "string" ? (
          <Typography variant="h4" fontWeight={400}>
            {titleHeader}
          </Typography>
        ) : (
          titleHeader
        )}
      </Stack>

      {regulationPdf || regulationHtml ? (
        <Stack justifyContent="center" width={{ xs: "100%", sm: "inherit" }}>
          <Divider
            sx={{
              borderColor: "#0000001F",
              mt: "15px",
              mb: "22px",
              display: {
                xs: "inherit",
                sm: "none"
              }
            }}
          />

          <Button
            size="medium"
            variant="contained"
            css={styles.regulamento__button}
            onClick={() => handleOnOpen()}
            startIcon={<FileText size={24} color="#FFFFFF" fontWeight={600} />}
            fullWidth={false}
          >
            Regulamento da parceria
          </Button>
        </Stack>
      ) : null}

      <Regulation
        isOpen={isOpen}
        onClose={onClose}
        pdf={regulationPdf}
        termsHtml={regulationHtml}
        allowDownload={regulationPdf ? allowDownload : false}
      />
    </Stack>
  );
};
